import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'prgov-cronograma',
  templateUrl: './cronograma.component.html',
  styleUrls: ['./cronograma.component.scss']
})
export class CronogramaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
